import { pushCellHistory } from "../pushCellHistory";
import { State } from "../types";

export type MergeCellsAction = Readonly<{
  type: "MERGE CELLS";
}>;

export const mergeCells = (state: State, _action: MergeCellsAction): State => {
 const selectedCells = state.cells.filter(cell => cell.selected);

  let minX = Math.min(...selectedCells.map(x => x.minX));
  let maxX = Math.max(...selectedCells.map(x => x.maxX));
  let minY = Math.min(...selectedCells.map(x => x.minY));
  let maxY = Math.max(...selectedCells.map(x => x.maxY));

  let insertionPoint = state.cells.findIndex(cell => {
    return selectedCells.includes(cell);
  })
  let mergedCell = {
    ...state.cells[insertionPoint],
    minX,
    maxX,
    minY,
    maxY,
    selected: true,
    selectedBorders: []
  };

  let newCells = state.cells.filter(cell => !cell.selected)

  let overlappingCell = newCells.findIndex(cell => {
    // Check if one rectangle is to the left of the other
    if (cell.maxX <= minX || maxX <= cell.minX) {
      return false;
    }
    // Check if one rectangle is above the other
    if (cell.maxY <= minY || maxY <= cell.minY) {
      return false;
    }
    return true;
  });
  if (overlappingCell > -1) {
    return state;
  }

  newCells.splice(insertionPoint, 0, mergedCell);

  return pushCellHistory(state, newCells);
};
